import React, { Component } from "react";

import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CTextarea
} from "@coreui/react";
import { ChromePicker } from "react-color";
import {
  Ellipse,
  Image as ImageKonva,
  Layer,
  Line,
  Rect,
  Shape,
  Stage,
  Star,
  Text,
  Transformer
} from "react-konva";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
// import Konva from 'konva';

import "gifler";

const Rect2 = ({ shapeProps, isSelected, onSelect, onChange, draggable }) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <React.Fragment>
      <Rect
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        {...shapeProps}
        draggable={draggable}
        onDragEnd={e => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y()
          });
        }}
        onTransformEnd={e => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation: node.rotation(),
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY)
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </React.Fragment>
  );
};

const Ellipse2 = ({
  shapeProps,
  isSelected,
  onSelect,
  onChange,
  draggable
}) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <React.Fragment>
      <Ellipse
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        {...shapeProps}
        draggable={draggable}
        onDragEnd={e => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y()
          });
        }}
        onTransformEnd={e => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation: node.rotation(),
            radiusX: Math.max(5, (node.width() / 2) * scaleX),
            radiusY: Math.max(5, (node.height() / 2) * scaleY)
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </React.Fragment>
  );
};

const Triangle2 = ({
  shapeProps,
  isSelected,
  onSelect,
  onChange,
  draggable
}) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();
  const [width, setWidth] = React.useState(shapeProps.width);
  const [height, setHeight] = React.useState(shapeProps.height);

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  React.useEffect(() => {
    shapeRef.current.getSelfRect = () => {
      const ret = {
        x: shapeProps.v1.x,
        y: shapeProps.v2.y,
        width,
        height
      };
      return ret;
    };
  }, [shapeProps.v1.x, shapeProps.v2.y, width, height]);

  return (
    <React.Fragment>
      <Shape
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        {...shapeProps}
        sceneFunc={(context, shapeTriangle) => {
          context.beginPath();
          context.moveTo(shapeProps.v1.x, shapeProps.v1.y);
          context.lineTo(shapeProps.v2.x, shapeProps.v2.y);
          context.lineTo(shapeProps.v3.x, shapeProps.v3.y);
          context.closePath();
          context.fillStrokeShape(shapeTriangle);
        }}
        draggable={draggable}
        onDragEnd={e => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y()
          });
        }}
        onTransformEnd={e => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          node.scaleX(1);
          node.scaleY(1);

          setWidth(Math.max(5, node.width() * scaleX));
          setHeight(Math.max(5, node.height() * scaleY));

          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation: node.rotation(),
            v1: {
              x: 0,
              y: shapeProps.v1.y * scaleY
            },
            v2: {
              x: shapeProps.v2.x * scaleX,
              y: 0
            },
            v3: {
              x: shapeProps.v3.x * scaleX,
              y: shapeProps.v3.y * scaleY
            },
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(5, node.height() * scaleY)
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </React.Fragment>
  );
};

const Star2 = ({ shapeProps, isSelected, onSelect, onChange, draggable }) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <React.Fragment>
      <Star
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        {...shapeProps}
        draggable={draggable}
        onDragEnd={e => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y()
          });
        }}
        onTransformEnd={e => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation: node.rotation(),
            innerRadius: Math.max(5, (node.width() / 4) * scaleX),
            outerRadius: Math.max(5, (node.height() / 2) * scaleY)
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
          enabledAnchors={[
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
          ]}
        />
      )}
    </React.Fragment>
  );
};

const Text2 = ({ shapeProps, isSelected, onSelect, onChange, draggable }) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <React.Fragment>
      <Text
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        {...shapeProps}
        draggable={draggable}
        onDragEnd={e => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y()
          });
        }}
        onTransformEnd={e => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          node.scaleX(1);
          node.scaleY(1);

          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation: node.rotation(),
            fontSize: shapeProps.fontSize * scaleX
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
          enabledAnchors={[
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
          ]}
        />
      )}
    </React.Fragment>
  );
};

const Image2 = ({ shapeProps, isSelected, onSelect, onChange, draggable }) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();
  const [image, setImage] = React.useState(null);

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }

    shapeProps.image.addEventListener("load", handleLoad());
  }, [isSelected, shapeProps.src, shapeProps.image]);

  const handleLoad = () => {
    setImage(shapeProps.image);
  };

  return (
    <React.Fragment>
      <ImageKonva
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        image={image}
        {...shapeProps}
        draggable={draggable}
        width={shapeProps.width !== "" ? shapeProps.width : null}
        height={shapeProps.height !== "" ? shapeProps.height : null}
        onDragEnd={e => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y()
          });
        }}
        onTransformEnd={e => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation: node.rotation(),
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY)
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </React.Fragment>
  );
};

const Gif2 = ({ shapeProps, isSelected, onSelect, onChange, draggable }) => {
  const trRef = React.useRef();
  const imageRef = React.useRef(null);
  const canvas = React.useMemo(() => {
    const node = document.createElement("canvas");
    return node;
  }, []);

  React.useEffect(() => {
    let anim;
    window.gifler(shapeProps.src).get(a => {
      anim = a;
      anim.animateInCanvas(canvas);
      anim.onDrawFrame = (ctx, frame) => {
        ctx.drawImage(frame.buffer, frame.x, frame.y);
        imageRef.current.getLayer().draw();
      };
    });
    return () => anim.stop();
  }, [shapeProps.src, canvas]);

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([imageRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <React.Fragment>
      <ImageKonva
        onClick={onSelect}
        onTap={onSelect}
        ref={imageRef}
        image={canvas}
        draggable={draggable}
        {...shapeProps}
        onDragEnd={e => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y()
          });
        }}
        onTransformEnd={e => {
          const node = imageRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation: node.rotation(),
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY)
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </React.Fragment>
  );
};

const Line2 = ({ shapeProps, isSelected, onSelect, onChange, draggable }) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <React.Fragment>
      <Line
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        points={shapeProps.points}
        stroke={shapeProps.color}
        rotation={shapeProps.rotation}
        x={shapeProps.x !== null ? shapeProps.x : null}
        y={shapeProps.y !== null ? shapeProps.y : null}
        strokeWidth={5}
        tension={0.5}
        lineCap="round"
        draggable={draggable}
        globalCompositeOperation={
          shapeProps.tool === "eraser" ? "destination-out" : "source-over"
        }
        onDragEnd={e => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y()
          });
        }}
        onTransformEnd={e => {
          const node = shapeRef.current;

          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation: node.rotation()
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
          enabledAnchors={[]}
        />
      )}
    </React.Fragment>
  );
};

class Criarte extends Component {
  constructor(props) {
    super(props);

    this.stageRef = React.createRef();

    this.state = {
      // lazyRadius: 1,
      // brushRadius: 1,
      // imageSaved: "",
      colorPicker: "#000",
      isDrawing: false,
      tool: "pen",
      shapes: [
        {
          type: "background",
          image: new window.Image(),
          src: "",
          id: 1,
          width: 0,
          height: 0
        }
      ],
      selectedId: null,
      abbleToDraw: true,
      // showColor: false,
      iconActive: 0,
      showBackgroundGallery: false,
      backgroundGalleryList: [],
      backgroundGallerySelectedId: null,
      showStampGallery: false,
      stampGalleryList: [],
      stampGallerySelectedId: null,
      showInputText: false,
      inputTextValue: "",
      width: 0,
      height: 0,
      showCriarteGallery: false,
      criarteGalleryList: [],
      criarteGallerySelectedId: null,
      saving: false
    };
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    let obj = {
      user_id: this.props.user.user.id
    };

    axios
      .all([
        axios.get(`${URL.api}literarte/criarte/stamps`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}literarte/criarte/background`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}literarte/criarte/productions`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (respStamps, respBackground, respProductions) => {
            let stampGalleryList = [];
            if (respStamps.data.success) {
              stampGalleryList = respStamps.data.data;
            }

            let backgroundGalleryList = [];
            if (respBackground.data.success) {
              backgroundGalleryList = respBackground.data.data;
            }

            let criarteGalleryList = [];
            if (respProductions.data.success) {
              criarteGalleryList = respProductions.data.data;
            }

            this.setState({
              stampGalleryList,
              backgroundGalleryList,
              criarteGalleryList
            });
          },
          error => {
            this.error(error.response.statusText);
          }
        )
      );

    let width = document.getElementById("areaCanvas").offsetWidth;
    if (width > 1000) {
      width = 1000;
    }
    let height = width * 0.558;

    let shapes = [];
    this.state.shapes.forEach(shape => {
      shapes.push(shape);
    });
    shapes[0].width = width - 2;
    shapes[0].height = height - 2;

    this.setState({
      width,
      height,
      shapes
    });

    document.addEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = e => {
    switch (e.keyCode) {
      case 46:
        this.state.shapes.forEach(shape => {
          if (shape.id === this.state.selectedId && shape.type !== "text") {
            this.deleteShape();
          }
        });
        break;
      default:
        break;
    }
  };

  handleMouseDown = e => {
    if (this.state.abbleToDraw) {
      this.setState(
        {
          isDrawing: true
        },
        () => {
          const pos = e.target.getStage().getPointerPosition();
          this.setState({
            shapes: [
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.shapes,
              {
                type: "line",
                // eslint-disable-next-line react/no-access-state-in-setstate
                tool: this.state.tool,
                // eslint-disable-next-line react/no-access-state-in-setstate
                id: this.state.shapes[this.state.shapes.length - 1].id + 1,
                points: [pos.x, pos.y],
                // eslint-disable-next-line react/no-access-state-in-setstate
                color: this.state.colorPicker
              }
            ]
          });
        }
      );
    } else if (e.target === e.target.getStage()) {
      this.setState({
        selectedId: null,
        showInputText: false,
        inputTextValue: ""
      });
    }
  };

  handleMouseMove = e => {
    if (!this.state.isDrawing) {
      return;
    }

    const stage = e.target.getStage();
    const point = stage.getPointerPosition();
    let lastLine = this.state.shapes[this.state.shapes.length - 1];
    // add point
    lastLine.points = lastLine.points.concat([point.x, point.y]);
    // lastLine.id = this.state.shapes.length;

    // replace last
    this.state.shapes.splice(this.state.shapes.length - 1, 1, lastLine);
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      shapes: this.state.shapes.concat()
    });
  };

  downloadURI(uri, name) {
    let link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  handleDragStart = e => {
    const id = e.target.id();
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      shapes: this.state.shapes.map(shape => ({
        ...shape,
        isDragging: shape.id === id
      }))
    });
  };

  handleDragEnd = e => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      shapes: this.state.shapes.map(shape => ({
        ...shape,
        isDragging: false
      }))
    });
  };

  addShape = type => {
    let shapes = [];
    this.state.shapes.forEach(shape => {
      shapes.push(shape);
    });

    let obj = {};
    obj.rotation = 0;
    let selectedId = null;
    let showInputText = false;
    let inputTextValue = "";
    let {
      abbleToDraw,
      backgroundGallerySelectedId,
      iconActive,
      showBackgroundGallery,
      showStampGallery,
      stampGallerySelectedId
    } = this.state;
    if (type === "circle") {
      obj.type = "circle";
      obj.x = 50;
      obj.y = 50;
      obj.radiusX = 50;
      obj.radiusY = 50;
      obj.fill = this.state.colorPicker;
    } else if (type === "rect") {
      obj.type = "rect";
      obj.x = 0;
      obj.y = 0;
      obj.width = 100;
      obj.height = 100;
      obj.fill = this.state.colorPicker;
    } else if (type === "triangle") {
      obj.type = "triangle";
      obj.v1 = {
        x: 0,
        y: 100
      };
      obj.v2 = {
        x: 50,
        y: 0
      };
      obj.v3 = {
        x: 100,
        y: 100
      };
      obj.width = 100;
      obj.height = 100;
      obj.fill = this.state.colorPicker;
    } else if (type === "star") {
      obj.type = "star";
      obj.x = 50;
      obj.y = 50;
      obj.numPoints = 5;
      obj.innerRadius = 25;
      obj.outerRadius = 50;
      obj.fill = this.state.colorPicker;
    } else if (type === "text") {
      obj.type = "text";
      obj.x = 15;
      obj.y = 15;
      obj.text = "Altere o texto na caixa abaixo";
      obj.fontSize = 30;
      obj.fontFamily = "Calibri";
      obj.fill = this.state.colorPicker;
      selectedId = shapes[shapes.length - 1].id + 1;
      showInputText = true;
      iconActive = 2;
      abbleToDraw = false;
    } else if (type === "background") {
      backgroundGallerySelectedId = null;
      showBackgroundGallery = false;
      if (this.state.backgroundGallerySelectedId === 0) {
        shapes[0].image = new Image();
        shapes[0].src = "";
      } else {
        this.state.backgroundGalleryList.forEach(image => {
          if (image.id === this.state.backgroundGallerySelectedId) {
            shapes[0].image = new Image();
            shapes[0].image.src = image.path;
            shapes[0].src = image.path;
          }
        });
      }
    } else if (type === "stamp") {
      stampGallerySelectedId = null;
      showStampGallery = false;
      obj.x = 0;
      obj.y = 0;
      this.state.stampGalleryList.forEach(stamp => {
        if (stamp.id === this.state.stampGallerySelectedId) {
          if (stamp.type === "image") {
            obj.type = "image";
            this.state.stampGalleryList.forEach(image => {
              if (image.id === this.state.stampGallerySelectedId) {
                obj.image = new Image();
                obj.image.src = image.path;
                obj.src = image.path;
              }
            });
          } else if (stamp.type === "gif") {
            obj.type = "gif";
            this.state.stampGalleryList.forEach(stamp => {
              if (stamp.id === this.state.stampGallerySelectedId) {
                obj.src = stamp.path;
              }
            });
          }
        }
      });
    }

    if (type !== "background") {
      obj.id = shapes[shapes.length - 1].id + 1;
      shapes.push(obj);
    }

    this.setState({
      shapes,
      selectedId,
      showInputText,
      inputTextValue,
      iconActive,
      abbleToDraw,
      showBackgroundGallery,
      backgroundGallerySelectedId,
      showStampGallery,
      stampGallerySelectedId
    });
  };

  selectShape = shape => {
    let selectedId;
    let inputTextValue = "";
    let showInputText = false;
    if (this.state.selectedId === shape.id) {
      selectedId = null;
    } else if (!this.state.abbleToDraw && shape.id !== 1) {
      selectedId = shape.id;
      if (shape.type === "text") {
        inputTextValue = shape.text;
        showInputText = true;
      }
    }
    if (shape.id === 1) {
      selectedId = null;
    }

    this.setState({
      selectedId,
      inputTextValue,
      showInputText
    });
  };

  updateShape = newShape => {
    let shapes = [];
    this.state.shapes.forEach(shape => {
      if (newShape.id === shape.id) {
        shapes.push(newShape);
      } else {
        shapes.push(shape);
      }
    });

    this.setState({
      shapes
    });
  };

  deleteShape = () => {
    let shapes = [];
    this.state.shapes.forEach(shape => {
      if (shape.id !== this.state.selectedId) {
        shapes.push(shape);
      } else if (shape.id === 1) {
        shape.image = new Image();
        shape.src = "";
        shapes.push(shape);
      } else if (shape.tool === "eraser") {
        shapes.push(shape);
      }
    });

    this.setState({
      shapes,
      selectedId: null,
      showInputText: false
    });
  };

  checkDeselect = e => {
    // deselect when clicked on empty area
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      this.setState({
        selectedId: null,
        showInputText: false,
        inputTextValue: ""
      });
    }
  };

  handleChangeComplete = color => {
    let shapes = [];
    this.state.shapes.forEach(shape => {
      if (shape.id === this.state.selectedId) {
        if (shape.type === "line") {
          shape.color = color.hex;
        } else {
          shape.fill = color.hex;
        }
      }
      shapes.push(shape);
    });

    this.setState({
      colorPicker: color.hex,
      shapes
    });
  };

  editTextShape = e => {
    let shapes = [];
    this.state.shapes.forEach(shape => {
      if (shape.id === this.state.selectedId) {
        shape.text = e.target.value;
      }
      shapes.push(shape);
    });

    this.setState({
      inputTextValue: e.target.value,
      shapes
    });
  };

  loadShapes = () => {
    let shapesAux = [];
    this.state.criarteGalleryList.forEach(criarte => {
      if (criarte.id === this.state.criarteGallerySelectedId) {
        shapesAux = JSON.parse(criarte.content);
        shapesAux[0].image = new Image();
        shapesAux[0].image.src = shapesAux[0].src;
      }
    });

    let shapes = [];
    shapesAux.forEach(shape => {
      if (shape.type === "image") {
        shape.image = new Image();
        shape.image.src = shape.src;
      }
      shapes.push(shape);
    });

    this.setState({
      shapes,
      selectedId: null,
      showInputText: false,
      inputTextValue: "",
      showCriarteGallery: false,
      criarteGallerySelectedId: null,
      abbleToDraw: true,
      tool: "pen",
      iconActive: 0
      // isSelected: null
    });
  };

  handleExport = () => {
    this.setState(
      {
        selectedId: null
      },
      () => {
        if (
          this.state.shapes.length === 1 &&
          this.state.shapes[0].image.src === ""
        ) {
          toastr.error("Erro", "Você não pode salvar uma imagem vazia.");
        } else {
          let content = JSON.stringify(this.state.shapes);

          const uri = this.stageRef.current.toDataURL();

          let obj = {
            base64: uri,
            user_id: this.props.user.user.id,
            content
          };

          this.setState({ saving: true });

          axios
            .post(`${URL.api}gallery/insert/base64`, obj, {
              headers: {
                authorization: `Bearer ${this.props.user.token}`,
                "Access-Control-Allow-Origin": "*"
              }
            })
            .then(resp => {
              this.setState({
                abbleToDraw: true,
                tool: "pen",
                shapes: [
                  {
                    // eslint-disable-next-line react/no-access-state-in-setstate
                    ...this.state.shapes[0],
                    image: new Image(),
                    src: ""
                  }
                ],
                // isSelected: null,
                showInputText: false,
                inputTextValue: "",
                saving: false
              });
              this.props.saveImage(resp.data.data);
            });
        }
      }
    );
  };

  render() {
    return (
      <React.Fragment>
        <CModal
          show={this.state.showBackgroundGallery}
          onClose={() => this.setState({ showBackgroundGallery: false })}
          size="lg w-100 h-100 m-0 p-2 mw-100"
          style={{ width: "100%", height: "100%" }}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>Galeria de imagens de fundo</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div className="flex-1 overflow-auto">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(12, 1fr)",
                  gridGap: "10px"
                }}
              >
                <div
                  style={{
                    position: "relative",
                    overflow: "hidden",
                    paddingBottom: "100%"
                  }}
                >
                  <img
                    className="w-100 h-100"
                    style={{
                      position: "absolute",
                      objectFit: "contain",
                      borderRadius: "0.25rem",
                      cursor: "pointer"
                    }}
                    src="/imgs/criarte/fundos/Fundo0.png"
                    alt=""
                  />
                  <div
                    className="w-100 h-100"
                    style={{
                      position: "absolute",
                      zIndex: 100,
                      border: "1px solid #d8dbe0",
                      transition: "0.15s ease-in-out",
                      borderRadius: "0.25rem",
                      cursor: "pointer",
                      backgroundColor:
                        this.state.backgroundGallerySelectedId === 0
                          ? "rgba(91, 129, 225, 0.49)"
                          : ""
                    }}
                    onClick={() =>
                      this.setState({ backgroundGallerySelectedId: 0 })
                    }
                  />
                </div>
                {this.state.backgroundGalleryList.map(image => (
                  <div
                    key={image.id}
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      paddingBottom: "100%"
                    }}
                  >
                    <img
                      className="w-100 h-100"
                      style={{
                        position: "absolute",
                        objectFit: "contain",
                        borderRadius: "0.25rem",
                        cursor: "pointer"
                      }}
                      src={image.path}
                      alt=""
                    />
                    <div
                      className="w-100 h-100"
                      style={{
                        position: "absolute",
                        zIndex: 100,
                        border: "1px solid #d8dbe0",
                        transition: "0.15s ease-in-out",
                        borderRadius: "0.25rem",
                        cursor: "pointer",
                        backgroundColor:
                          image.id === this.state.backgroundGallerySelectedId
                            ? "rgba(91, 129, 225, 0.49)"
                            : ""
                      }}
                      onClick={() =>
                        this.setState({ backgroundGallerySelectedId: image.id })
                      }
                    />
                  </div>
                ))}
              </div>
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton
              color="primary"
              onClick={() => this.addShape("background")}
            >
              Selecionar
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal
          show={this.state.showStampGallery}
          onClose={() => this.setState({ showStampGallery: false })}
          size="lg w-100 h-100 m-0 p-2 mw-100"
          style={{ width: "100%", height: "100%" }}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>Galeria de carimbos</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div className="flex-1 overflow-auto">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(12, 1fr)",
                  gridGap: "10px"
                }}
              >
                {this.state.stampGalleryList.map(image => (
                  <div
                    key={image.id}
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      paddingBottom: "100%"
                    }}
                  >
                    <img
                      className="w-100 h-100"
                      style={{
                        position: "absolute",
                        objectFit: "contain",
                        borderRadius: "0.25rem",
                        cursor: "pointer"
                      }}
                      src={image.path}
                      alt=""
                    />
                    <div
                      className="w-100 h-100"
                      style={{
                        position: "absolute",
                        zIndex: 100,
                        border: "1px solid #d8dbe0",
                        transition: "0.15s ease-in-out",
                        borderRadius: "0.25rem",
                        cursor: "pointer",
                        backgroundColor:
                          image.id === this.state.stampGallerySelectedId
                            ? "rgba(91, 129, 225, 0.49)"
                            : ""
                      }}
                      onClick={() =>
                        this.setState({ stampGallerySelectedId: image.id })
                      }
                    />
                  </div>
                ))}
              </div>
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton color="primary" onClick={() => this.addShape("stamp")}>
              Selecionar
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          show={this.state.showCriarteGallery}
          onClose={() => this.setState({ showCriarteGallery: false })}
          size="lg w-100 h-100 m-0 p-2 mw-100"
          style={{ width: "100%", height: "100%" }}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>Galeria de produções</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div className="flex-1 overflow-auto">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(12, 1fr)",
                  gridGap: "10px"
                }}
              >
                {this.state.criarteGalleryList.map(image => (
                  <div
                    key={image.id}
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      paddingBottom: "100%"
                    }}
                  >
                    <img
                      className="w-100 h-100"
                      style={{
                        position: "absolute",
                        objectFit: "contain",
                        borderRadius: "0.25rem",
                        cursor: "pointer"
                      }}
                      src={URL.public + image.path + image.name}
                      alt=""
                    />
                    <div
                      className="w-100 h-100"
                      style={{
                        position: "absolute",
                        zIndex: 100,
                        border: "1px solid #d8dbe0",
                        transition: "0.15s ease-in-out",
                        borderRadius: "0.25rem",
                        cursor: "pointer",
                        backgroundColor:
                          image.id === this.state.criarteGallerySelectedId
                            ? "rgba(91, 129, 225, 0.49)"
                            : ""
                      }}
                      onClick={() =>
                        this.setState({ criarteGallerySelectedId: image.id })
                      }
                    />
                  </div>
                ))}
              </div>
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton color="primary" onClick={() => this.loadShapes()}>
              Selecionar
            </CButton>
          </CModalFooter>
        </CModal>
        <CCol lg="12" style={{ marginTop: "10px" }}>
          <CContainer>
            <CRow>
              <CCol
                style={{
                  color: "#f48d51",
                  display: "flex",
                  alignContent: "center"
                }}
              >
                <div
                  style={{ alignSelf: "center", cursor: "pointer" }}
                  onClick={() => this.props.closeLiterarte()}
                >
                  Voltar&nbsp;
                </div>
                <i
                  className="fa fa-angle-left fa-2x font-weight-bold cursor"
                  onClick={() => this.props.closeLiterarte()}
                ></i>
              </CCol>
            </CRow>
            <CRow>
              <CCol lg="10">
                <div
                  id="areaCanvas"
                  style={{
                    backgroundColor: "#FFF",
                    border: "2px solid #aab6bd",
                    borderRadius: "20px",
                    minWidth: this.state.width,
                    minHeight: this.state.height,
                    maxWidth: 1000,
                    maxHeight: 558
                  }}
                >
                  <Stage
                    width={this.state.width - 2}
                    height={this.state.height - 2}
                    onMouseDown={e => this.handleMouseDown(e)}
                    onMousemove={e => this.handleMouseMove(e)}
                    onMouseup={() => this.setState({ isDrawing: false })}
                    ref={this.stageRef}
                  >
                    <Layer>
                      {this.state.shapes.map((shape, index) => (
                        <React.Fragment key={index}>
                          {shape.type === "background" ? (
                            shape.image.src !== "" ? (
                              <Image2
                                shapeProps={shape}
                                isSelected={false}
                                onSelect={() => this.selectShape(shape)}
                                onChange={newShape =>
                                  this.updateShape(newShape)
                                }
                                draggable={false}
                              />
                            ) : null
                          ) : shape.type === "circle" ? (
                            <Ellipse2
                              shapeProps={shape}
                              isSelected={shape.id === this.state.selectedId}
                              onSelect={() => this.selectShape(shape)}
                              onChange={newShape => this.updateShape(newShape)}
                              draggable={!this.state.abbleToDraw}
                            />
                          ) : shape.type === "rect" ? (
                            <Rect2
                              shapeProps={shape}
                              isSelected={shape.id === this.state.selectedId}
                              onSelect={() => this.selectShape(shape)}
                              onChange={newShape => this.updateShape(newShape)}
                              draggable={!this.state.abbleToDraw}
                            />
                          ) : shape.type === "star" ? (
                            <Star2
                              shapeProps={shape}
                              isSelected={shape.id === this.state.selectedId}
                              onSelect={() => this.selectShape(shape)}
                              onChange={newShape => this.updateShape(newShape)}
                              draggable={!this.state.abbleToDraw}
                            />
                          ) : shape.type === "image" ? (
                            <Image2
                              shapeProps={shape}
                              isSelected={shape.id === this.state.selectedId}
                              onSelect={() => this.selectShape(shape)}
                              onChange={newShape => this.updateShape(newShape)}
                              draggable={!this.state.abbleToDraw}
                            />
                          ) : shape.type === "gif" ? (
                            <Gif2
                              shapeProps={shape}
                              isSelected={shape.id === this.state.selectedId}
                              onSelect={() => this.selectShape(shape)}
                              onChange={newShape => this.updateShape(newShape)}
                              draggable={!this.state.abbleToDraw}
                            />
                          ) : shape.type === "line" ? (
                            <Line2
                              shapeProps={shape}
                              isSelected={shape.id === this.state.selectedId}
                              onSelect={() => this.selectShape(shape)}
                              onChange={newShape => this.updateShape(newShape)}
                              draggable={
                                !this.state.abbleToDraw &&
                                shape.tool !== "eraser"
                              }
                            />
                          ) : shape.type === "text" ? (
                            <Text2
                              shapeProps={shape}
                              isSelected={shape.id === this.state.selectedId}
                              onSelect={() => this.selectShape(shape)}
                              onChange={newShape => this.updateShape(newShape)}
                              draggable={!this.state.abbleToDraw}
                            />
                          ) : shape.type === "triangle" ? (
                            <Triangle2
                              shapeProps={shape}
                              isSelected={shape.id === this.state.selectedId}
                              onSelect={() => this.selectShape(shape)}
                              onChange={newShape => this.updateShape(newShape)}
                              draggable={!this.state.abbleToDraw}
                            />
                          ) : null}
                        </React.Fragment>
                      ))}
                    </Layer>
                  </Stage>
                </div>
                {this.state.showInputText ? (
                  <CTextarea
                    style={{ marginTop: "10px", borderRadius: "20px" }}
                    name="textArea"
                    id="textArea"
                    rows="4"
                    placeholder="Digite o texto aqui"
                    value={this.state.inputTextValue}
                    onChange={e => this.editTextShape(e)}
                  />
                ) : null}
              </CCol>
              <CCol lg="2">
                <CRow style={{ marginBottom: "10px" }}>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-pencil"
                        style={{
                          fontSize: "1.5rem",
                          color:
                            this.state.iconActive === 0 ? "#f48d51" : "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() =>
                          this.setState({
                            tool: "pen",
                            abbleToDraw: true,
                            iconActive: 0,
                            // isSelected: null,
                            showInputText: false,
                            inputTextValue: ""
                          })
                        }
                      ></i>
                    </div>
                  </CCol>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-eraser"
                        style={{
                          fontSize: "1.5rem",
                          color:
                            this.state.iconActive === 1 ? "#f48d51" : "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() =>
                          this.setState({
                            tool: "eraser",
                            abbleToDraw: true,
                            iconActive: 1,
                            // isSelected: null,
                            showInputText: false,
                            inputTextValue: ""
                          })
                        }
                      ></i>
                    </div>
                  </CCol>
                </CRow>
                <CRow style={{ marginBottom: "10px" }}>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-circle"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() => this.addShape("circle")}
                      ></i>
                    </div>
                  </CCol>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-square"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() => this.addShape("rect")}
                      ></i>
                    </div>
                  </CCol>
                </CRow>
                <CRow style={{ marginBottom: "10px" }}>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-caret-up"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() => this.addShape("triangle")}
                      ></i>
                    </div>
                  </CCol>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-star"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() => this.addShape("star")}
                      ></i>
                    </div>
                  </CCol>
                </CRow>
                <CRow style={{ marginBottom: "10px" }}>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-text-width"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() => this.addShape("text")}
                      ></i>
                    </div>
                  </CCol>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-picture-o"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() =>
                          this.setState({ showBackgroundGallery: true })
                        }
                      ></i>
                    </div>
                  </CCol>
                </CRow>
                <CRow style={{ marginBottom: "10px" }}>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-arrows"
                        style={{
                          fontSize: "1.5rem",
                          color:
                            this.state.iconActive === 2 ? "#f48d51" : "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() =>
                          this.setState({ abbleToDraw: false, iconActive: 2 })
                        }
                      ></i>
                    </div>
                  </CCol>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-file-image-o"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() =>
                          this.setState({ showStampGallery: true })
                        }
                      ></i>
                    </div>
                  </CCol>
                </CRow>
                <CRow style={{ marginBottom: "10px" }}>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-trash"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() => this.deleteShape()}
                      ></i>
                    </div>
                  </CCol>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-file-o"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() =>
                          this.setState({
                            abbleToDraw: true,
                            tool: "pen",
                            shapes: [
                              {
                                // eslint-disable-next-line react/no-access-state-in-setstate
                                ...this.state.shapes[0],
                                image: new Image(),
                                src: ""
                              }
                            ],
                            // isSelected: null,
                            showInputText: false,
                            inputTextValue: ""
                          })
                        }
                      ></i>
                    </div>
                  </CCol>
                </CRow>
                <CRow style={{ marginBottom: "10px" }}>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem"
                      }}
                    >
                      <i
                        className="fa fa-history"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() =>
                          this.setState({ showCriarteGallery: true })
                        }
                      ></i>
                    </div>
                  </CCol>
                  <CCol>
                    <div
                      style={{
                        textAlign: "center",
                        backgroundColor: "#023047",
                        width: "3rem",
                        height: "3rem",
                        border: "1px solid black",
                        borderRadius: "50%",
                        padding: "0.7rem",
                        opacity: this.state.saving ? 0.5 : 1,
                        pointerEvents: this.state.saving ? "none" : "all"
                      }}
                    >
                      <i
                        className="fa fa-save"
                        style={{
                          fontSize: "1.5rem",
                          color: "#e5e5e5",
                          cursor: "pointer"
                        }}
                        onClick={() => this.handleExport()}
                      ></i>
                    </div>
                  </CCol>
                </CRow>
                <CRow style={{ justifyContent: "center" }}>
                  <ChromePicker
                    color={this.state.colorPicker}
                    onChangeComplete={color => this.handleChangeComplete(color)}
                  />
                </CRow>
              </CCol>
            </CRow>
          </CContainer>
        </CCol>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Criarte);
